import React, { Component } from 'react'
import { range } from 'lodash'
import { Layer, Line, Circle, Rect, Ellipse, Wedge, Ring, Arc, Label, Arrow } from 'react-konva'
import { Markup } from '../../views/LabelBuilder/LabelBuilder.slice'
import unitUtil from '../../utils/unit.util'

interface Props {
  stage: Markup['stage']
}

export default class Grid extends Component<Props> {

  gridLine (x1: number, y1: number, x2: number, y2: number) {
    const key = `${x1}${y1}${x2}${y2}`
    return (
      <Line
        key={key}
        stroke="#ffcccc"
        strokeWidth={1}
        points={[x1, y1, x2, y2]} />
    )
  }

  gridCircle (x1: number, y1: number, x2: number, y2: number) {
    const key = `${x1}${y1}${x2}${y2}`
    return (
      <Circle
      key={key}
      x={window.innerWidth / 2}
      y={window.innerHeight / 2}
      radius={50}
      fill="red"
      stroke="#ffcccc"
      strokeWidth={1}
    />
     
    )
  }

  gridRect (x1: number, y1: number, x2: number, y2: number) {
    const key = `${x1}${y1}${x2}${y2}`
    return (
      <Rect
      key={key}
      x={window.innerWidth / 2}
      y={window.innerHeight / 2}
      radius={50}
      fill="red"
      stroke="#ffcccc"
      strokeWidth={1}
    />
     
    )
  }

  gridEllipse (x1: number, y1: number, x2: number, y2: number) {
    const key = `${x1}${y1}${x2}${y2}`
    return (
      <Ellipse
      radiusX={50}
      radiusY={90}
      key={key}
      x={window.innerWidth / 2}
      y={window.innerHeight / 2}
      radius={50}
      fill="red"
      stroke="#ffcccc"
      strokeWidth={1}
    />
     
    )
  }

  gridWedge (x1: number, y1: number, x2: number, y2: number) {
    const key = `${x1}${y1}${x2}${y2}`
    return (
      <Wedge
      angle={50}
      key={key}
      x={window.innerWidth / 2}
      y={window.innerHeight / 2}
      radius={50}
      fill="red"
      stroke="#ffcccc"
      strokeWidth={1}
    />
     
    )
  }

  gridRing (x1: number, y1: number, x2: number, y2: number) {
    const key = `${x1}${y1}${x2}${y2}`
    return (
      <Ring
      innerRadius={50}
      outerRadius={20}
      angle={50}
      key={key}
      x={window.innerWidth / 2}
      y={window.innerHeight / 2}
      radius={50}
      fill="red"
      stroke="#ffcccc"
      strokeWidth={1}
    />
     
    )
  }

  gridArc (x1: number, y1: number, x2: number, y2: number) {
    const key = `${x1}${y1}${x2}${y2}`
    return (
      <Arc
      innerRadius={50}
      outerRadius={20}
      angle={50}
      key={key}
      x={window.innerWidth / 2}
      y={window.innerHeight / 2}
      radius={50}
      fill="red"
      stroke="#ffcccc"
      strokeWidth={1}
    />
     
    )
  }

  gridLabel (x1: number, y1: number, x2: number, y2: number) {
    const key = `${x1}${y1}${x2}${y2}`
    return (
      <Label
      innerRadius={50}
      outerRadius={20}
      angle={50}
      key={key}
      x={window.innerWidth / 2}
      y={window.innerHeight / 2}
      radius={50}
      fill="red"
      stroke="#ffcccc"
      strokeWidth={1}
    />
     
    )
  }

  gridArrow (x1: number, y1: number, x2: number, y2: number) {
    const key = `${x1}${y1}${x2}${y2}`
    return (
      <Arrow
      points={[0, 0, 50, 0, 50, -50]}
      innerRadius={50}
      outerRadius={20}
      angle={50}
      key={key}
      x={window.innerWidth / 2}
      y={window.innerHeight / 2}
      radius={50}
      fill="red"
      stroke="#ffcccc"
      strokeWidth={1}
      pointerLength={20}
      pointerWidth={20}
    />
     
    )
  }

  get stageWidth () {
    const { unit, width } = this.props.stage
    return unitUtil.unitToPixel(unit, width)
  }

  get stageHeight () {
    const { unit, height } = this.props.stage
    return unitUtil.unitToPixel(unit, height)
  }

  render () {
    const { stage } = this.props
    const { size, visibility } = stage.grid
    const columnRange = range(0, this.stageWidth + size, size)
    const rowRange = range(0, this.stageHeight + size, size)
    const canShow = Boolean(size) && visibility === 'on'
    return (
      canShow && (
        <Layer id="grid">
          {columnRange.map((x) => this.gridLine(x, 0, x, this.stageHeight))}
          {/*{columnRange.map((x) => this.gridCircle(x, 0, x, this.stageHeight))}*/}
          {/*{columnRange.map((x) => this.gridRect(x, 0, x, this.stageHeight))}*/}
          {/*{columnRange.map((x) => this.gridEllipse(x, 0, x, this.stageHeight))}*/}
          {/*{columnRange.map((x) => this.gridWedge(x, 0, x, this.stageHeight))}*/}
          {/*{columnRange.map((x) => this.gridRing(x, 0, x, this.stageHeight))}*/}
          {/*{columnRange.map((x) => this.gridArc(x, 0, x, this.stageHeight))}*/}
          {columnRange.map((x) => this.gridLabel(x, 0, x, this.stageHeight))}
          {/*{columnRange.map((x) => this.gridArrow(x, 0, x, this.stageHeight))}*/}
          {rowRange.map((y) => this.gridLine(0, y, this.stageWidth, y))}
        </Layer>
      )
    )
  }
}
